export default function (nga, admin, properties, activities) {

    var values = admin.getEntity('values');
    values.listView()
        .title('{{ "Values" | translate }}')
        .fields([
            nga.field('name')
              .isDetailLink(true),
            nga.field('property_id', 'reference')
                .targetEntity(properties)
                .targetField(nga.field('name'))
                .label('Property'),
            nga.field('position', 'number'),
            nga.field('activity.name', 'string')
                .sortable(false)
        ])
        .filters([
            nga.field('property_id', 'reference')
                .targetEntity(properties)
                .targetField(nga.field('name'))
                .label('Property'),
            nga.field('q', 'template')
                .label('')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
        ])
        .actions(['create', 'filter'])
        .listActions(['edit']);
    values.creationView()
        .fields([
            nga.field('name')
                .validation({ required: true }),
            // TODO: show also the activity that references this property
            nga.field('property_id', 'reference')
                .targetEntity(properties)
                .targetField(
                    nga.field('name').map(function(value, entry){
                        return entry['activity.name'] + ' - ' + value;
                    })
                )
                .label('Property')
                .validation({ required: true }),
            nga.field('position', 'number'),
            nga.field('', 'template')
                .label('')
                .editable(false)
                .template('<span class="pull-right"><ma-filtered-list-button entity-name="values" filter="{ value_id: entry.values.id }" size="sm"></ma-filtered-list-button></span>')

        ]);
    values.editionView()
        .title('{{ "EDIT" | translate }}')
        .fields(values.creationView().fields());

    return values;
}



// WEBPACK FOOTER //
// ./js/values/config.js